import React, { useState } from "react";

const RateCard = () => {
  // Sample rate data
  const [rates, setRates] = useState([
    // { country: "United States", rate: "$ 0.05", flag: "🇺🇸" },
    // { country: "Canada", rate: "$ 0.05", flag: "🇨🇦" },
    // { country: "Australia", rate: "$ 0.05", flag: "🇦🇺" },
  ]);

  const [searchTerm, setSearchTerm] = useState("");

  // Filter countries based on search term
  const filteredRates = rates.filter((rate) =>
    rate.country.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <div className="mx-auto ">
        <h1 className="text-sm font-semibold text-black mb-4">Rate Card</h1>
        <input

          type="text"
          placeholder="Search..."
          className="w-full px-4 py-2 mb-6 bg-gray-200 text-gray-900 border border-gray-700 rounded-lg placeholder:text-gray-500"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-700">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-xs font-medium text-gray-900"
                >
                  Country
                </th>


                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-xs font-medium text-gray-900"
                >
                  Calling Rate


                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {filteredRates.length > 0 ? (
                filteredRates.map((rate, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900 flex items-center">
                      <span className="mr-2 text-lg">{rate.flag}</span>
                      {rate.country}


                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                      {rate.rate}
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={2}
                    className="whitespace-nowrap px-3 py-4 text-xs text-gray-400 text-center"
                  >
                    No Data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RateCard;
